module.exports = __webpack_public_path__ + "img/mbf.aa05dc97.png";